export enum CategorySelectionState {
  SELECTED = 'SELECTED',
  UN_SELECTED = 'UN_SELECTED',
  PARTIAL_SELECTION = 'PARTIAL_SELECTION',
}

export enum TcAvailable {
  UNAVAILABLE = 0,
  PARTIAL = 1,
  FULL = 2,
}
